module.exports = __webpack_public_path__ + "media/images/landing/icons/youtube-5267ecdd7c269c765e16b7bb41d4fe0f.svg";